//REACT 
import { Helmet } from "react-helmet";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

//HOOKS, HELPERS, SERVICES
import { useQuery } from "Hooks/index";
import useSession from "Hooks/session.hook";
import usePagination from "Hooks/pagination.hook";
import { decode } from "Helpers/enc";
import { toaster } from "Helpers/toaster";
import { fetchIncidentReport } from "Services/incident-report.services";


//STYLE
import { CloseCircleOutlined } from "@ant-design/icons";
import './algo-interface.scss'

//COMPONENTS
import { StackScreen, Button } from "@life-line-lab/components-react"
import { Row, Col } from 'antd';
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

const AlgorithmInterfacePage = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const query = useQuery();

    const handleCloseStackScreen = () => {
        history.push(`/parcels-order-processing/parcels`)
    }

    return (
        <StackScreen
            title={
                <div>
                    <img
                        alt={t("alt.logo")}
                        src="/assets/images/banner_logo.png"
                        height={30}
                    />
                </div>
            }
            isOpen={true}
            renderHeader={<div></div>}
            onClose={handleCloseStackScreen}>
            <div className="algo-interface">
                <h1>Routing Algorithm Interface</h1>
                <Row>
                    <Col span={4}>
                        <Button
                            label="First Mile"
                            type="default"
                            size="large"
                            onClick={() => {
                                console.log('first mile')
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            label="First Mile + Mid Mile"
                            type="default"
                            size="large"
                            onClick={() => {
                                console.log('first & mid mile')
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            label="Mid-Mile"
                            type="default"
                            size="large"
                            onClick={() => {
                                console.log('mid mile')
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            label="End-to-End"
                            type="default"
                            size="large"
                            onClick={() => {
                                console.log('end-to-end')
                            }}
                        />
                    </Col>
                    <Col span={4}>
                        <Button
                            label="Last-Mile"
                            type="default"
                            size="large"
                            onClick={() => {
                                console.log('last mile')
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        RESULTS WILL BE HERE
                    </Col>
                </Row>
            </div>
        </StackScreen>
    )
}

export default AlgorithmInterfacePage;